export class EventVersion {
    cv:number = 0;
    lmv:number = 0;
    isDisabled:boolean = false;
    isDisabledBySA:boolean = false
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/event-version.ts